/* @flow */

import { compose } from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import { getBraindateId } from '@braindate/domain/lib/braindate/util';

import MarketRedirectPromptCard from './MarketRedirectPromptCard';
import { guidanceFirstInvitation } from 'src/shared/app/market/guidance/settings/guidanceSettings';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import { pendingBraindatesRoute } from 'src/shared/app/base/route/setting/routeSettings';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';
import {
  getPendingBraindateInvitations,
  getBraindateOtherParticipant,
} from 'src/shared/domain/braindate/util/braindateUtil';
import { getAllBraindates } from 'src/shared/domain/braindate/selector/braindateSelectors';
import UserAvatar, {
  large,
} from 'src/shared/components/domain/user/avatar/UserAvatar';
import { getMembershipGuidanceObjectId } from 'src/shared/domain/membership/util/membershipUtil';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';

const mapStateToProps = (state: Object, ownProps: Object): Object => {
  const selfUser = getSelf(state);
  const membership = getMembership(state);
  const braindateId = membership
    ? getMembershipGuidanceObjectId(membership)
    : null;

  const braindates = getAllBraindates(state);
  const receivedInvitations = selfUser
    ? getPendingBraindateInvitations(braindates, selfUser)
    : [];

  // Comapare the id returned by the backend with the list of invitation.
  // The one that correspond is the right braindate to display.
  let firstInvitation;

  receivedInvitations.forEach((invitation) => {
    if (getBraindateId(invitation) === braindateId) {
      firstInvitation = invitation;
    }
  });

  const otherUser =
    selfUser &&
    firstInvitation &&
    getBraindateOtherParticipant(firstInvitation, selfUser);

  return {
    ...ownProps,
    guidanceLabel: guidanceFirstInvitation,
    route: getRoutePath(pendingBraindatesRoute, state),
    icon: otherUser && (
      <UserAvatar user={otherUser} variant={large} onDarkBackground />
    ),
  };
};

export default compose(connect(mapStateToProps))(MarketRedirectPromptCard);
